// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useEffect, useState } from 'react'
import { useLocales } from 'react-localized'
import * as iso3166 from 'i18n-iso-countries'
import {
  IonButton,
  IonContent,
  IonFooter,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonToolbar
} from '@ionic/react'
import {CountryList} from './CountryList'


interface CountrySelectorProps {
  children?: React.ReactNode
  disabled?: boolean
  helpText?: string
  label: string
  title: string
  onClosed?: (code: string | null) => void
  onSelected(code: string): void
  successMessage?: string
  value?: string | null
}


const CountryModalSelector: React.FC<CountrySelectorProps> = (props) => {
  const {disabled, label, title} = props
  const {gettext, locale} = useLocales()
  const [selected, setSelected] = useState<string | null>(props.value || null)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const onClosed = props.onClosed || (() => {})

  useEffect(() => {
    if (!!isOpen) {
      setIsOpen(false)
    }
    if (selected !== null) {
      props.onSelected(selected)
    }
  }, [selected])

  return (
    <>
      <IonModal
        className="page-modal"
        isOpen={isOpen}
        mode="ios"
        onIonModalDidDismiss={() => setIsOpen(false)}
        style={{
          justifyContent: "left",
          maxWidth: "512px"
        }}
      >
        <IonContent>
          <CountryList
            heading={gettext("Countries and Regions")}
            onSelected={(code) => {
              onClosed(selected)
              if (code === selected) {
                setIsOpen(false)
                return
              }
              setSelected(code)
            }}
            selected={selected}
          >
            <IonItem lines="none">
              <IonLabel>
                <h2 style={{fontSize: "18px"}}>{title}</h2>
              </IonLabel>
            </IonItem>
          </CountryList>
        </IonContent>
        <IonFooter mode="md">
          <IonToolbar>
            <IonButton
              color="medium"
              fill="clear"
              onClick={() => setIsOpen(false)}
              style={{
                width: "100%"
              }}
            >
              {gettext("Close")}
            </IonButton>
          </IonToolbar>
        </IonFooter>
      </IonModal>
      <IonItem lines="none" style={{cursor: "pointer"}} onClick={() => setIsOpen(!disabled && true)}>
        <IonInput
          disabled={disabled}
          helperText={props.helpText || gettext("Click or tap to select a country.")}
          label={label}
          labelPlacement="stacked"
          readonly={true}
          placeholder={gettext("No country selected")}
          value={(!!selected) ? iso3166.getName(selected, locale) : null}
        >

        </IonInput>
      </IonItem>
    </>
  )
}

export {CountryModalSelector}